/**
 * Determines whether a color is perceptually light using the W3C brightness formula.
 * Accepts a hex string (e.g. "#ffffff") or a CSS variable reference (e.g. "var(--my-color)").
 * CSS variable references are resolved against the document root at call time.
 * @param color - A hex color string or CSS var() reference
 * @returns `true` if the color is light, `false` if it is dark
 */
function colorIsLight(color: string): boolean {
    let resolved = color;

    const varMatch = resolved.match(/^var\((--[^)]+)\)$/);
    if (varMatch) {
        resolved = getComputedStyle(document.documentElement).getPropertyValue(varMatch[1]).trim();
    }

    const hex = resolved.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155;
}

export { colorIsLight };
